/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Einvoice_Stuck_WaitingInputs */

const vi_einvoice_stuck_waiting = /** @type {(inputs: Einvoice_Stuck_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chờ MISA trả lời, tự kiểm tra lại tới ${i?.time}.`)
};

/**

* @param {Einvoice_Stuck_WaitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_waiting = /** @type {((inputs: Einvoice_Stuck_WaitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_WaitingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_waiting(inputs)
});